import React from 'react';
import './OrderFilters.css';
import { getPlatformType } from '../../utils/platformUtils';
import { useTranslation } from '../../hooks/useTranslation';

function OrderFilters({ searchTerm, setSearchTerm, startDate, setStartDate, endDate, setEndDate, currentTab, personFilter, setPersonFilter, creatorNames }) {
  const { t } = useTranslation('orders');
  const containerClass = currentTab === 'DISPATCHED' ? 'dispatched-search-filters' : 'search-bar';
  const platformType = getPlatformType();

  // Get unique creator names for the dropdown
  const uniqueCreators = React.useMemo(() => {
    const creators = Object.values(creatorNames).filter(name => name && name.trim() !== '');
    return [...new Set(creators)].sort();
  }, [creatorNames]);

  // Check if we have any creators available
  const hasCreators = uniqueCreators.length > 0;

  // Determine if we should limit dropdown size for PWA mobile platforms
  const shouldLimitDropdownSize = ['ios-pwa', 'android-pwa'].includes(platformType);
  const maxVisibleOptions = 6; // Show maximum 6 options at once

  const clearAllFilters = () => {
    setStartDate('');
    setEndDate('');
    setPersonFilter('');
  };

  return (
    <div className={containerClass}>
      <div className="search-bar">
        <input
          type="text"
          placeholder={t('filters.search')}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      {currentTab === 'DISPATCHED' && (
        <div className="date-filters">
          <div className="date-input">
            <label>
              {t('filters.startDate')}:
            </label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div className="date-input">
            <label>
              {t('filters.endDate')}:
            </label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
          {hasCreators && (
            <div className="person-filter">
              <label>
                {t('filters.personFilter')}:
              </label>
              <select
                value={personFilter}
                onChange={(e) => setPersonFilter(e.target.value)}
                className="person-select"
                size={shouldLimitDropdownSize ? Math.min(maxVisibleOptions, uniqueCreators.length + 1) : undefined}
                multiple={false}
              >
                <option value="">
                  {t('filters.allPeople')}
                </option>
                {uniqueCreators.map((creator, index) => (
                  <option key={index} value={creator}>
                    {creator}
                  </option>
                ))}
              </select>
            </div>
          )}
          <button className="clear-filter-x" onClick={clearAllFilters}>
            &times;
          </button>
        </div>
      )}
    </div>
  );
}

export default OrderFilters; 